<template>
  <Panel title="组件配置">

    <el-form
      ref="dxpMessageContent"
      label-position="top"
      :model="value"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item label="senderid" prop="senderid">
            <el-input v-model="value.senderid"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="receiverid" prop="receiverid">
            <el-input v-model="value.receiverid"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="icCard" prop="icCard">
            <el-input v-model="value.icCard"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="copCode" prop="copCode">
            <el-input v-model="value.copCode"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </Panel>
</template>
<script>

export default {
  props: {
    value: { type: Object, default: () => {} },
    uuid: { type: String, default: '' },
  },
  data: () => ({
    data: '',
    mouldData: '',
    loading: false,

    radio: 0,
  }),
  created() {
    // this.$set(this.value, 'deviceName', this.value['deviceName']);
    this.$set(this.value, 'senderid', this.value['senderid']);
    this.$set(this.value, 'receiverid', this.value['receiverid']);
    this.$set(this.value, 'icCard', this.value['icCard']);
    this.$set(this.value, 'copCode', this.value['copCode']);
  },
  watch: {},
  mounted() {},
  methods: {
    validate() {
        return this.$refs.dxpMessageContent.validate();
    },
    init() {},
    fmt() {
      try {
        let json = JSON.parse(this.data);
        this.data = JSON.stringify(json, '  ', 4);
      } catch (e) {
        this.$message.warning('JSON格式非法');
        this.$refs.input.focus();
      }
    },
  },
};
</script>

<style scoped></style>
